import { TErrorsState, TValuesState } from '../types/internal';
import { TValidators } from '../types/public';

export interface IGetErrorsFromFieldsParams<T> {
  validators: TValidators<T>;
  values: TValuesState<T>;
}

export const getErrorsFromFields = <T>(params: IGetErrorsFromFieldsParams<T>): TErrorsState => {
  const { validators, values } = params;

  const newErrorsObj = {} as TErrorsState;

  for (const key in validators) {
    /* istanbul ignore else */
    if (validators.hasOwnProperty(key)) {
      const validator = validators[key];

      const error = validator(values[key], values);

      if (error) {
        newErrorsObj[key] = error;
      }
    }
  }

  return newErrorsObj;
};
